import { reactive } from "vue";

/**
 * ルート遷移の進行状況（ナビバー上の細いプログレスバー用）。
 *
 * - start(): 遷移開始。SHOW_DELAY_MS 以内に終われば何も表示しない（フリッカー防止）
 * - finish(): 遷移完了。100% まで伸ばしてからフェードアウト
 * - 表示中は本物の進捗が取れないため、80% 付近まで徐々に伸びる擬似進捗にする
 *
 * router/index.js の beforeEach / afterEach / onError から呼ぶ。
 */
const SHOW_DELAY_MS = 150;
const TRICKLE_MS = 200;
const HIDE_DELAY_MS = 250;

const state = reactive({
  visible: false,
  progress: 0,
});

let showTimer = 0;
let trickleTimer = 0;
let hideTimer = 0;
let pending = false;

function clearTimers() {
  clearTimeout(showTimer);
  clearInterval(trickleTimer);
  clearTimeout(hideTimer);
  showTimer = trickleTimer = hideTimer = 0;
}

function start() {
  clearTimers();
  pending = true;
  showTimer = setTimeout(() => {
    if (!pending) return;
    state.progress = 15;
    state.visible = true;
    trickleTimer = setInterval(() => {
      // 80% で頭打ち。残りは finish() で埋める
      if (state.progress < 80) {
        state.progress += Math.max(1, (80 - state.progress) * 0.15);
      }
    }, TRICKLE_MS);
  }, SHOW_DELAY_MS);
}

function finish() {
  pending = false;
  clearTimeout(showTimer);
  clearInterval(trickleTimer);
  if (!state.visible) return;
  state.progress = 100;
  hideTimer = setTimeout(() => {
    state.visible = false;
    state.progress = 0;
  }, HIDE_DELAY_MS);
}

export function useRouteProgress() {
  return { state, start, finish };
}
